import PubSub from "underpub-js";
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

window.requestAnimationFrame = window.requestAnimationFrame.bind(window);
gsap.registerPlugin(ScrollTrigger);

var ButtonTextLink = function(options) {

	this.options = {
		$el: false,
		baseClass: 'atom-ButtonTextLink',
	};

	$.extend(true, this.options, options);

};

ButtonTextLink.prototype.init = function() {

	var self = this;

	const $button = self.options.$el;
	const $buttonIcon = $button.find(`.${self.options.baseClass}__icon`);
	const $buttonUnderline = $button.find(`.${self.options.baseClass}__underline`);

	self.hoverAnimationTl = gsap
		.timeline({
			paused: true,
			reversed: true
		})
		.to($buttonIcon, {
			x: 0,
			opacity: 1,
			visibility: "visible",
			duration: .3,
			ease: "expo.inout",
		}, "<")
		.to($buttonUnderline, {
			right: -22,
			duration: .3,
			ease: "expo.inout",
		}, "<");
	

	$button.on('mouseenter', () => {
		self.hoverAnimationTl.timeScale(1).play();
	});

	$button.on('mouseleave', () => {
		self.hoverAnimationTl.timeScale(1.3).reverse();
	});

};

export default ButtonTextLink;
